import { Gender, PhoneType } from "../../types";
import { PostAddress } from "../../api/commercial/generated-types";

export const AttorneyValues = {
  NONE: "NONE",
  OTHER: "OTHER",
  ADMIN: "ADMIN",
  NOT_CHOSEN: "NOT_CHOSEN",
};
export type Attorney = (typeof AttorneyValues)[keyof typeof AttorneyValues];

export interface PersonType {
  nationality: string;
  birthdate: string;
  gender?: Gender;
  firstName: string;
  lastName: string;
  fullStreet: string;
  address: PostAddress;
  mobile: PhoneType;
  emailBusiness: string;
  isSameAsAdmin: boolean;
}

export interface PowerOfAttorneyModel {
  attorneyType: Attorney;
  attorneysData?: PersonType[];
  adminAttorneysData?: PersonType[];
}
